import { createElement, PropTypes } from 'rlink-react';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';
import themeable from 'rlink-theme/themeable';

function ArticleBody ({theme, html, pathForContent}) {
  let parsed = html;
  let matchAll = html.match(/.*?src="(\/content\/.*?)"/g);
  if (matchAll) {
    for (let i = 0; i < matchAll.length; i++) {
      let match = matchAll[i].match(/.*?src="(\/content\/.*?)"/);
      parsed = parsed.replace(match[1], pathForContent(match[1]));
    }
  }
  return (
    <div
      className={theme.ArticleBody}
      dangerouslySetInnerHTML={{__html: parsed}} />
  );
}

ArticleBody.propTypes = {
  html: PropTypes.string,
  pathForContent: PropTypes.func,
};

themeable(ArticleBody, {
  classes: [
    'ArticleBody',
  ],
});

export default connectToPathForContent(ArticleBody);



// WEBPACK FOOTER //
// ./lib/rlink-blog/ArticleBody.jsx